import React, { useState, useContext, useRef, useEffect} from "react";

import {BackHandler}  from 'react-native';

import {useNavigation} from '@react-navigation/native'

import * as util from '../util/util'

import {buscarProposta, alterarProposta, excluirItensProposta, novoItemProposta} from '../ws/ws_propostas'

import contexto from '../util/contexto'

import { ViewDegradeVertical} from '../componentes/ViewDegradeVertical';

import { useFocusEffect } from '@react-navigation/native';

import FormularioProposta from '../componentes/FormularioProposta'

import {carregamento} from '../componentes/Carregamento'

import {MSG_ERRO_PADRAO, TELA_MINHAS_PROPOSTAS, TELA_CHAT,
	DNC_TIPO_SERVICO_PROPOSTA, TELA_NOVA_DENUNCIA,
	TELA_DETALHE_PROPOSTA} from '../util/constantes'

import {buscar_loja} from '../ws/ws_usuarios'

import Scroll from '../componentes/Scroll'



export default function TelaDetalheProposta(){
   
	const {valorContexto, setValorContexto} = useContext(contexto);

	const navegacao = new useNavigation();
	
	const formularioPropostaRef  = useRef(null);

	const [sincronizando, setSincronizando] = useState(true) 
	
	const [carregado, setCarregado] = useState(false) 
	
	const [proposta, setProposta] = useState(null)
	
	const [loja, setLoja] = useState(null)

	

	const voltar = () => {
			
		navegacao.replace(util.processaVoltar())
		
		return true;
	};
	

	const buscarDados= async ()=>{
		
		setCarregado(false);

		setSincronizando(true);
		
		let aux = await buscarProposta(valorContexto.idProposta);
		
		if(util.temConteudo(aux)){
			
			setProposta(aux);
			
			setLoja(await buscar_loja(aux.fk_usuario))

			setCarregado(true)
		}
		
		setSincronizando(false)
	}
	
	
	useFocusEffect(React.useCallback(() => {

		util.print("TelaDetalheProposta");
		
		BackHandler.addEventListener('hardwareBackPress', voltar);

		buscarDados();

		return () => {
		  BackHandler.removeEventListener('hardwareBackPress', voltar);
		};	
	}, []));
	
	
	const prepararFormulario= async ()=>{
	
		if(carregado== true && proposta!=null)								
	
			formularioPropostaRef.current.setDados({"id": proposta.id, 
													"titulo": proposta.titulo,
													"situacao_pedido": proposta.situacao_pedido,
													"descricao_pedido": proposta.descricao_pedido,
													"descricao": proposta.descricao,
													"data_expiracao": proposta.data_expiracao,
													"valor_frete": proposta.valor_frete,
													"prazo_entrega": proposta.prazo_entrega,
													"prazo_servico": proposta.prazo_servico,
													"forma_pagamento": proposta.forma_pagamento,
													"nome_proponente": proposta.nome_proponente,
													"solicitante": loja!=null?loja.nome:null,
													"imagem_pedido": proposta.imagem},  
													proposta.itens,
													proposta.fk_usuario != valorContexto.idUsuarioAtual);
		
	}
	
	
	useEffect(() => {
		
		let isMounted = true;
		
		if(isMounted)
			prepararFormulario()
		
		return () => {isMounted = false; };

	}, [sincronizando]);
	
	
	async function salvar(dados){
		
        if( await alterarProposta(valorContexto.idProposta, dados.descricao, dados.valorTotal) == null){
                
            formularioPropostaRef.current.salvarErro(MSG_ERRO_PADRAO);
            return;
        }

		if( await excluirItensProposta(valorContexto.idProposta) == null){
                
            formularioPropostaRef.current.salvarErro(MSG_ERRO_PADRAO);
            return;
        }

		for (const item of dados.itens) {
			
			item['id_proposta'] = valorContexto.idProposta;
			
			let retorno = await novoItemProposta(item);
			
			if(retorno==null){
				
				formularioPropostaRef.current.salvarErro(MSG_ERRO_PADRAO);
				return;
			}
		}
		
        formularioPropostaRef.current.salvarSucesso();
		
		navegacao.replace(TELA_MINHAS_PROPOSTAS)
    }


	function abrirChat(){
		
		console.log("chat");
		
		// pode ir null, o valorContexto.idProposta ja esta configurado com segunda opcao
	
		setValorContexto(prevState =>({...prevState, idChat: proposta.fk_chat}));

		util.setVoltar(TELA_DETALHE_PROPOSTA);

		navegacao.navigate(TELA_CHAT);
	}


	return (
		<ViewDegradeVertical titulo="Proposta de Orçamento" voltar={()=>voltar()}>
			{(sincronizando) ?
				(carregamento(sincronizando)):
				(<Scroll> 
					<FormularioProposta ref={formularioPropostaRef} salvar={salvar} abrirChat={abrirChat}/>
				
					<Bloco>  
							<View style={{marginTop:10}}/> 
							<View style={{alignItems:'center'}}>	
								<Botao 
									acao={()=>{
										
										setValorContexto(prevState =>({...prevState, tipoDenuncia: DNC_TIPO_SERVICO_PROPOSTA}));

										setValorContexto(prevState =>({...prevState, idRelacaoDenuncia: valorContexto.idProposta}));

										navegacao.replace(TELA_NOVA_DENUNCIA)
									}}
									somente_texto={true}
									texto="Denunciar Proposta"/>   
							</View>
							<View style={{marginTop:10}}/> 
					</Bloco> 
				</Scroll>)	
			} 
		</ViewDegradeVertical>	
	);
}
